"use client";

import React from "react";
import { Instagram, Twitter, Facebook } from "lucide-react";
import Link from "next/link";

const PRIMARY = "#003B5C";
const GOLD = "#E3A130";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-[#003B5C] text-white py-10 md:py-12 border-t border-[#003B5C]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* MAIN AREA */}
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-start">
          {/* LEFT: BRAND & ADDRESS */}
          <div className="flex-1 min-w-[240px]">
            <div className="mb-4">
              <p className="text-sm font-semibold">Business Development of UIII</p>
            </div>

            <div className="text-xs sm:text-sm text-zinc-200 space-y-1">
              <p>UIII Rectorate Building Level 2</p>
              <p>Jalan Raya Bogor KM. 33.5, Cisalak, Sukmajaya</p>
              <p>Depok, Jawa Barat 16416, Indonesia</p>
              <p>dpu@uiii.ac.id</p>
            </div>

            <p className="mt-6 text-[11px] sm:text-xs text-zinc-300">
              © Business Development of UIII {year}. All rights reserved.
            </p>
          </div>

          {/* MIDDLE: NAV COLUMNS */}
          <div className="flex-[2] w-full grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-6 text-xs sm:text-sm">
            {/* QUICKLINKS */}
            <div>
              <h4
                className="font-semibold mb-3 tracking-wide"
                style={{ color: GOLD }}
              >
                QUICKLINKS
              </h4>
              <ul className="space-y-2 text-zinc-100">
                <li>
                  <Link href="/about" className="hover:underline">
                    About
                  </Link>
                </li>
                <li>
                  <Link href="/about/faq" className="hover:underline">
                    FAQ
                  </Link>
                </li>
              </ul>
            </div>

            {/* BUSINESS UNIT */}
            <div>
              <h4
                className="font-semibold mb-3 tracking-wide"
                style={{ color: GOLD }}
              >
                BUSINESS UNIT
              </h4>
              <ul className="space-y-2 text-zinc-100">
                <li>
                  <Link href="/merchandise" className="hover:underline">
                    Merchandise
                  </Link>
                </li>
                <li>
                  <Link href="/mice" className="hover:underline">
                    MICE
                  </Link>
                </li>
                <li>
                  <Link href="/accommodation" className="hover:underline">
                    Accommodation
                  </Link>
                </li>
                <li>
                  <Link href="/daycare" className="hover:underline">
                    Daycare
                  </Link>
                </li>
                <li>
                  <Link href="/f&b/catering" className="hover:underline">
                    Catering
                  </Link>
                </li>
                <li>
                  <Link href="/f&b" className="hover:underline">
                    Cafetaria
                  </Link>
                </li>
                <li>
                  <Link href="/other" className="hover:underline">
                    Others
                  </Link>
                </li>
              </ul>
            </div>

            {/* COOPERATION */}
            <div>
              <h4
                className="font-semibold mb-3 tracking-wide"
                style={{ color: GOLD }}
              >
                COOPERATION
              </h4>
              <ul className="space-y-2 text-zinc-100">
                <li>
                  <Link href="/cooperation" className="hover:underline">
                    Open Partnership
                  </Link>
                </li>
                <li>
                  <Link href="/cooperation#partners" className="hover:underline">
                    Partners
                  </Link>
                </li>
              </ul>
            </div>

            {/* ENDOWMENT FUND */}
            <div>
              <h4
                className="font-semibold mb-3 tracking-wide"
                style={{ color: GOLD }}
              >
                ENDOWMENT
              </h4>
              <ul className="space-y-2 text-zinc-100">
                <li>
                  <a 
                    href="https://old.uiii.ac.id/uiii-endowment-fund" 
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:underline"
                  >
                    Donation
                  </a>
                </li>
              </ul>
            </div>
          </div>

          {/* RIGHT: SOCIAL ICONS */}
          <div className="flex flex-col items-end gap-4">
            <a
              href="https://instagram.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="p-2 rounded-full hover:bg-white/10"
              aria-label="Instagram"
            >
              <Instagram className="w-5 h-5" />
            </a>
            <a
              href="https://twitter.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="p-2 rounded-full hover:bg-white/10"
              aria-label="Twitter / X"
            >
              <Twitter className="w-5 h-5" />
            </a>
            <a
              href="https://facebook.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="p-2 rounded-full hover:bg-white/10"
              aria-label="Facebook"
            >
              <Facebook className="w-5 h-5" />
            </a>
            <a
              href="https://www.tiktok.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="p-2 rounded-full hover:bg-white/10 text-sm font-semibold"
              aria-label="TikTok"
            >
              {/* Simple T symbol */}
              T
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}